module.exports = __webpack_public_path__ + "img/horizontal_4_5_r_pp3_1.80042e4f.png";